var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCssicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2018 65.4524L8.79736 4.8125H68.2029L62.7912 65.4428L38.464 72.1875L14.2018 65.4524Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 67.0333L58.1591 61.5832L62.7839 9.77178H38.5V67.0333Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 31.7408H48.3416L49.0201 24.1251H38.5V16.6873H57.1484L56.9704 18.6821L55.144 39.1786H38.5V31.7408Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5456 51.0558L38.5119 51.0654L30.2296 48.8276L29.7002 42.8962H22.2336L23.2756 54.5738L38.5095 58.8039L38.5456 58.7943V51.0558Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7088 38.8633L46.8136 48.8228L38.5193 51.0606V58.7991L53.7653 54.5738L53.8784 53.3177L55.1705 38.8633H47.7088Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5264 16.6873V24.1251H20.5613L20.4121 22.4527L20.0728 18.6821L19.8948 16.6873H38.5264ZM38.4999 31.7408V39.1786H30.3211L30.1719 37.5062L29.835 33.7356L29.6569 31.7408H38.4999Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssicon);
export default __webpack_public_path__ + "static/media/cssicon.9521d4f1e967b2bf52d291f5c9358d17.svg";
export { ForwardRef as ReactComponent };